<template>
		<md-button  class="surebutton" @click="clicks" v-loading="loading"
		:class="{isSuccess:type==1,isCancel:type==2,isSmall:type==3,isSure:size==1,isFullw:size==2,isyanzheng:size==3,isFullw45:size==4,isFull5:size==5}"
		:disabled="notClick" v-if="isJurisdiction(this.isShow)||isShow==undefined">{{name}}</md-button>
</template>

<script>
  import Vue from 'vue'
  import { MdButton } from 'vue-material/dist/components'
  Vue.use(MdButton)
  import isJurisdiction from '../../../utils/isJurisdiction.js'
  Vue.use(isJurisdiction);
	import { postApi, getApi } from "../../../api/commonApi"
	export default {
		name: "lbButton",
		props: ['name','loading','type','size','notClick','isShow'],
		data() {
			return {

			}
		},
		components: {

		},
		mounted() {
		},
		created() {
		},
		methods: {
			clicks(){
				this.$emit('clicks')
			}


		}
	}
</script>

<style scoped>
	@import 'lbButton.css';
</style>
<style>
	.isSmall .md-button-content{
		font-size:12px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/material/button/lbButton.vue